import { ModuleModel } from '../../module.model.interface';
import { ManifestType } from './form.manifest';

export class FormManifestCheckDescriptor implements ModuleModel {
  public discriminator = 'FormManifestCheckDescriptor';

  public errorMessage: string;
  public line: string;
  public manifestType: ManifestType;

  public htmlLine: string;

  constructor(options?: {
    errorMessage: string;
    line: string;
    manifestType: ManifestType;
  }) {

    if (options) {
      this.errorMessage = options.errorMessage;
      this.line = options.line;
      this.manifestType = options.manifestType;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/form.manifest/model/form.manifest.check.ts